import { AnyAction, Reducer } from 'redux';

export const STORE_FEEDBACK_REQUEST_TYPES = 'store/feedback-request-types';
export const STORE_MYINVOICES_DATA = 'store/myinvoices-data';

export interface FeedbackType {
    createdon: string;
    closedon: string;
    designapproval: string;
    destination: string;
    feedbacktype: string;
    fname: string;
    orderno: string;
    rating: string;
    reviewcomments: string;
    rowno: string;
    tool_preferred: string;
}

// Define an interface for the row data
export interface RowData {
  rowno: string;
  feedbackid: string;
  createdon: string;
  closedon: string;
  orderno: string;
  ds_ordersid: string;
  fname: string;
  destination: string;
  tool_preferred: string;
  designapproval: string;
  feedbacktype: string;
  rating: string;
  reviewcomments: string;
}

// Update initial state and interface
export interface FeedbackStateList {
    feedbackTypes: FeedbackType[];
    createdon: '';
    designapproval: '';
    destination: '';
    feedbacktype: '';
    fname: '';
    orderno: '';
    rating: '';
    reviewcomments: '';
    rowno: '';
    tool_preferred: '';
}
  
// Initial state
const initialState: FeedbackStateList = {
    feedbackTypes: [],
    createdon: '',
    designapproval: '',
    destination: '',
    feedbacktype: '',
    fname: '',
    orderno: '',
    rating: '',
    reviewcomments: '',
    rowno: '',
    tool_preferred: '',
};

// Reducer
const reducer: Reducer<FeedbackStateList> = (
    state = initialState,
    action: AnyAction
  ): FeedbackStateList => {
    switch (action.type) {
      case STORE_FEEDBACK_REQUEST_TYPES:
        return {
          ...state,
          feedbackTypes: action.feedbackTypes, // Now strongly typed as FeedbackType[]
        };
      default:
        return state;
    }
  };
  
export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/feedbackRequest.tsx